module.exports = __webpack_public_path__ + "media/images/ns banner2-1900x650-1f1986f9a4ec6da48fc3f000f6d31a82.png";